import { isMarketingHomeNavSectionId } from "@marketing/shared/lib/marketing-landing-home-sections";

/** Sections whose `/#id` navigation updates the landing URL hash via {@link scrollToMarketingAnchor}. */
export function isMarketingLandingHashSectionId(id: string): boolean {
	/** Legacy anchor for the CTA block (now `id="earlyaccess"`). */
	return isMarketingHomeNavSectionId(id) || id === "cta";
}
